import { useState } from 'react';

import BookingCalendarStaff from './BookingCalendarStaff';
export default function StaffcalendarPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="StaffcalendarPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><BookingCalendarStaff/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
